import { BrowserRouter,Routes,Route } from "react-router-dom";
import Auth from "./pages/auth";
import Branding from "./pages/branding";
import BrandingEdit from "./pages/brandingedit";
import graphic from "./media/graphic2.jpg"
import Landing from "./pages/landing";
import ConfirmPayment from "./pages/confirmPayment";
import AuthProvider from "./firebase/authprovider";
import Checkout from "./pages/checkoutpage";
import Checkoutreceipt from "./pages/checkoutreceipt"
import Admin from "./pages/admin";
import Protected from "./pages/protected";
import "./App.css"
function App() {
  return (
    <div className="App">
    
    <BrowserRouter >
    <AuthProvider />
    <Routes>
    <Route path="/" element={<Landing/>} />
     <Route path="/auth" element={<Auth/>} />
     <Route path="/branding" element={
      <Protected>
      <Branding/>

      </Protected>
    }
       />
     <Route path="/admin" element={
      <Protected>
      <Admin/>

      </Protected>
    }
       />
     <Route path="/receipt" element={
      <Protected>
      <Checkoutreceipt/>

      </Protected>
    }
       />
     <Route path="/confirmpayment" element={
      <Protected>
      <ConfirmPayment/>

      </Protected>
    }
       />
     <Route path="/checkout/:subTotal/" element={
      <Protected>
      <Checkout/>

      </Protected>
    }
       />
     <Route path="/branding-edit/:cartItemID" element={
            <Protected>
      <BrandingEdit/>

      </Protected>
      } />
    </Routes>
    </BrowserRouter >

    </div>
  );
}

export default App;


